
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student/student-wishlist",
      function () {
        return require("private-next-pages/student/student-wishlist/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student/student-wishlist"])
      });
    }
  